export { default as TagsGateway } from './TagsGateway'
export { default as TagsService } from './TagsService'
export { default as TagsServiceProvider } from './TagsServiceProvider'



// WEBPACK FOOTER //
// ./src/api/tags/index.js